<template>
    <div class="warpper padding-sm">
        <div class="classifys flex align-center">
            <router-link class="classify active" to="/branch/notice/list">我发布的</router-link>
            <router-link class="classify" to="/branch/notice">我接收的</router-link>
        </div>
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b> 通知公告 共{{ total }}条</b>
            <router-link v-if="user.isBranch" class="add-btn"
                         to="/branch/notice/edit/0">发布通知
            </router-link>
        </div>
        <div class="flex align-center justify-between margin-bottom-sm list-search">
            <el-input
                v-model="keyWord"
                placeholder="请输入通知公告标题关键字"
            ></el-input>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
        </div>
        <el-skeleton v-if="loading" :rows="10"/>
        <empty v-if="noData" :type="4"/>
        <div class="list-box">
            <div
                v-for="item in list"
                :key="item.id"
                class="item-box margin-bottom-sm"
            >
                <div class="title flex align-center justify-between">
                    <h3 class="ovHide">{{ item.title }}</h3>
                    <div class="state" @click="showReason(item.state_msg)">{{ item.state | status }}</div>
                </div>
                <div class="flex align-center justify-between item-info">
                    <div>
                        <p>
                            {{ item.add_time | timer }} <span class="padding-lr-xs"> </span
                        >{{ item.is_feedback === 1 ? "反馈通知" : "普通通知" }}
                        </p>
                        <p>
                            <span class="padding-right-xs">已读： <i>{{ item.read_num }}人</i> </span>
                            <span class="padding-right-xs">未读：<i>{{ item.not_read_num }}人</i> </span>
                            <span v-if="item.is_feedback === 1" class="padding-right-xs">已反馈： <i>{{
                                    item.feedback_num
                                }}人</i></span>
                            <span v-if="item.is_feedback === 1"
                                  class="padding-right-xs"> 未反馈：<i>{{ item.not_feedback_num }}人</i></span>
                        </p>
                    </div>
                    <div class="right-btn">
                        <router-link :to="'/branch/notice/detail/' + item.id">
                            <el-button class="have-color" round type="primary"
                            >{{ item.is_feedback === 1 ? '查看反馈' : '查看详情' }}
                            </el-button
                            >
                        </router-link>
                        <router-link
                            :to="'/branch/notice/edit/' + item.id"
                            class="margin-lr-xs"
                          v-if="user.isBranch">
                            <el-button class="have-color" round type="primary"
                            >编辑
                            </el-button
                            >
                        </router-link>

                        <el-button class="line-btn" round @click="delItem(item.id,item.feedback_num)" v-if="user.isBranch">删除</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="list.length > 0" class="flex align-center justify-between">
            <span>共{{ total }}条数据</span>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                layout="prev, pager, next, jumper"
                @current-change="getList"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>

import {zhDate} from '@//utils/utils'
import {noticeDel, noticeList} from "@/api/branch";

export default {
    name: "index",
    components: {},
    data() {
        return {
            page: 1,
            limit: 10,
            total: 0,
            keyWord: '',
            list: [],
            noData: false,
            loading: true,
        }
    },
    created() {
        this.$emit('setIndex', [1, 0], '通知公告')
        this.getList()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        //    删除通知公告
        delItem(id,feedback_num) {
            this.$confirm(feedback_num ? `此通知有${feedback_num}条反馈信息，是否确定删除？` :`此操作将删除该通知公告, 是否继续?`, '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await noticeDel(id)
            if (_state.status === 200) this.$message.success(_state.msg), this.getList()
        },
        search() {
            this.page = 1
            this.getList()
        },
        async getList() {
            this.list = []
            this.loading = true
            let _list = await noticeList(this.page, this.limit, this.keyWord)
            if (_list.status === 0) {
                this.list = []
                this.noData = true
                this.loading = false
            } else {
                this.loading = false, this.noData = false, this.list = _list.data, this.total = _list.count
            }
        },
        showReason(reason){
            if (!reason) return
            this.$confirm(reason, '拒绝原因', {
                confirmButtonText: '确定',
                showCancelButton:false,
                type: 'warning'
            })
        }
    },
    filters: {
        timer(val) {
            return zhDate(val * 1000)
        },
        status(type) {
            switch (Number(type)) {
                case 1:
                    return "待审核";
                case 2:
                    return "审核驳回";
                default:
                    return "审核通过";
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.warpper {
    background: #fff;
    border-radius: 10px;

    .classifys {
        margin-bottom: 20px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            color: #ffb400;
            border-radius: 0 6px 6px 0;

            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 6px 0 0 6px;
            }
        }
    }

    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
        }
    }

    .list-search {
        .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .item-box {
        border-radius: 10px;
        border: solid 1px #dae0e6;

        &:hover {
            background-color: #f3f7fb;
        }

        .title {
            height: 60px;
            padding: 5px 20px;
            color: #333333;
            border-bottom: 1px solid #dae0e6;
            h3{
                font-size: 18px;
                line-height: 18;
            }
            .state{
                font-size: 16px;
                cursor: pointer;
            }
        }

        .item-info {
            padding: 15px 20px;

            p {
                line-height: 24px;
                font-size: 14px;
                color: #999999;
                i {
                    color: #ffb400;
                }
            }
        }

        .right-btn {
            .have-color {
                background: #0a2240;
                border: 0;
            }
        }
    }
}
</style>